<template>
    <form @submit.prevent="updateTemplate">
        <div class="modal-row2 modal-height-max" id="myTabContent">
            <div class="tab-pane" id="template">
                <div class="modal-body template-builder-modal-body pl-0 pr-0">
                    <div class="template-builder-layout mt-negative-1">
                        <aside class="template-tags-panel labels-container">
                            <div class="tags-block template-tags-block">
                                <div class="template-tags-header">
                                    <div>
                                        <span class="template-tags-header__eyebrow">Variaveis</span>
                                        <h5>Tags</h5>
                                    </div>
                                    <i class="icon-label template-tags-header__icon"></i>
                                </div>
                                <div class="lablesContainerScroll">
                                    <div class="tags template-tags-category" v-for="(category, key) in tags.categories_raiz"
                                         :key="key">
                                        <a href="#" class="template-tags-category__toggle" @click="alterOpenRaiz(key)">
                                            <span class="template-tags-category__name">
                                                <i class="icon-label" :class="colorTag(key)"></i> {{ category }}
                                                <span class="template-tags-loop" v-if="['Compradores', 'Signatários'].includes(category)">Loop</span>
                                            </span>
                                            <span class="template-tags-category__chevron">
                                                <i class="icon-expand_more" v-if="!openRaiz[key]?.open"></i>
                                                <i class="icon-expand_less font-weight-bold"
                                                   v-if="openRaiz[key]?.open"></i>
                                            </span>
                                        </a>
                                        <div class="ml-2" v-show="openRaiz[key]?.open">
                                            <div class="tags template-tags-category template-tags-category--nested" v-for="(categoryc, keyc) in tags.items_raiz[key]"
                                                 :key="keyc"
                                                 :class="categoryc.open? 'border-bottom': ''">
                                                <a href="#" class="template-tags-category__toggle" @click="categoryc.open = !categoryc.open">
                                                    <span class="template-tags-category__name">
                                                        <i class="icon-label"></i> {{ keyc }}
                                                        <span class="template-tags-loop" v-if="['Testemunhas', 'Responsável'].includes(keyc)">Loop</span>
                                                    </span>
                                                    <span class="template-tags-category__chevron">
                                                        <i class="icon-expand_more" v-if="!categoryc.open"></i>
                                                        <i class="icon-expand_less font-weight-bold"
                                                           v-if="categoryc.open"></i>
                                                    </span>
                                                </a>
                                                <div v-show="categoryc.open">
                                                    <div class="template-tags-list d-flex flex-row align-items-start flex-wrap">
                                                        <div v-for=" (category) in categoryc"
                                                             :key="category.id">
                                                            <div class="badge badge-pill badge-light mb-1 mt-1 mr-1 template-tag-pill"
                                                                 :class="chooseColorNameTag(category.name_tag)"
                                                                 @click="copyText(`${key}${category.name_tag}`, category.traduction_tag)"
                                                                 :id="`${key}${category.name_tag}`">
                                                                {{ category.text }}
                                                                <i title="copiar" class="icon-copy"></i>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="tags template-tags-category" v-for="(category, key) in tags.categories" :key="key"
                                         :class="tags.items[key].open? 'border-bottom': ''">
                                        <a href="#" class="template-tags-category__toggle" @click="tags.items[key].open = !tags.items[key].open">
                                            <span class="template-tags-category__name">
                                                <i class="icon-label" :class="colorTag(key)"></i> {{ category }}
                                            </span>
                                            <span class="template-tags-category__chevron">
                                                <i class="icon-expand_more" v-if="!tags.items[key].open"></i>
                                                <i class="icon-expand_less font-weight-bold"
                                                   v-if="tags.items[key].open"></i>
                                            </span>
                                        </a>
                                        <div v-show="tags.items[key].open">
                                            <div class="template-tags-list d-flex flex-row align-items-start flex-wrap">
                                                <div v-for=" (category) in tags.items[key]" :key="category.id">
                                                    <div class="badge badge-pill badge-light mb-1 mt-1 mr-1 template-tag-pill"
                                                         :class="chooseColorNameTag(category.name_tag)"
                                                         @click="copyText(`${key}${category.name_tag}`, category.traduction_tag)"
                                                         :id="`${key}${category.name_tag}`">{{ category.text }}
                                                        <i title="copiar" class="icon-copy"></i>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </aside>
                        <main class="template-editor-panel">
                            <div class="template-editor-header">
                                <div>
                                    <span class="template-editor-header__eyebrow">Documento</span>
                                    <h5>Editor do template</h5>
                                </div>
                                <span class="template-editor-header__hint">
                                    <i class="icon-copy mr-1"></i>Clique em uma tag para copiar
                                </span>
                            </div>
                            <div class="row gutters">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div class="form-group">
                                        <label for="name" class="required">{{
                                                t('PROPOSAL.TEMPLATE_NAME')
                                            }}: </label>
                                        <input type="text" id="name" name="name" v-model="proposal.name"
                                               class="form-control"
                                               placeholder="Nome">
                                        <p class="validation" v-if="requiredName">
                                            {{ t('GENERAL.MSG.REQUIRED_FIELD') }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="row gutters">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                                    <div class="form-group">
                                        <label class="required">{{ t('PROPOSAL.TEMPLATE') }}: </label>
                                        <editor :init="configTinyMce"
                                                v-model="proposal.text"
                                                tinymce-script-src="https://tiny.r2app.com.br/js/tinymce/tinymce.min.js"></editor>
                                        <p class="validation" v-if="requiredText">
                                            {{ t('GENERAL.MSG.REQUIRED_FIELD') }}</p>
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-footer" style="justify-content: space-between">
            <div>
                <h5 class="ml-3" style="color: red; font-size: .7rem;">{{ t('GENERAL.REQUIRED_FIELDS') }} *</h5>
            </div>
            <div class="tags-block mb-2 ml-2 row left-content justify-content-between paddin">
                <div class="d-flex flex-row align-items-center">
                    <div class="tags" v-for="sub in subtitles" :key="sub.id">
                        <div class="mr-2">
                            {{ `Tipo ${sub.position}: ${sub.label}` }}
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <button data-cy="client_add_close" class="btn btn-secondary mr-2" data-dismiss="modal"
                        type="button">
                    {{ t('ACTIONS.CLOSE') }}
                </button>
                <button data-cy="client_add_save" class="btn btn-primary" type="submit">
                    {{ t('ACTIONS.SAVE') }}
                </button>
            </div>
        </div>
    </form>
</template>

<script>

import {useI18n} from 'vue-i18n';
import Tags from '../../services/Tags';
import Editor from '@tinymce/tinymce-vue';
import {useToast} from 'vue-toastification';
import Proposal from '../../services/Proposal';
import SimulatorConfig from '../../services/SimulatorConfig';

export default {
    name: 'createTemplateProposalComponent',
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast};
    },
    components: {
        Editor,
    },
    props: {
        itenIndex: {
            type: Object,
            required: true,
        },
    },
    watch: {
        itenIndex: function () {
            this.proposal = this.itenIndex;
            this.listTags();
            this.listLegends();
        },
    },
    data() {
        return {
            configTinyMce: {
                setup: (editor) => {
                    editor.on('paste', (e) => {
                        e.preventDefault();
                        const pastedText = (e.clipboardData || window.clipboardData).getData('text');
                        if (this.allTags[pastedText]) {
                            let highlightedTag;
                            if (this.allTags[pastedText].includes('{if_exists_start.') || this.allTags[pastedText].includes('{if_exists_end.')) {
                                highlightedTag = `<span class="tag-highlight-blue">${pastedText}</span> `;
                            } else if (this.allTags[pastedText].includes('{start_loop.') || this.allTags[pastedText].includes('{end_loop.')) {
                                highlightedTag = `<span class="tag-highlight-green">${pastedText}</span> `;
                            } else {
                                highlightedTag = `<span class="tag-highlight">${pastedText}</span> `;
                            }
                            editor.insertContent(highlightedTag);
                            const bookmark = editor.selection.getBookmark(2);
                            editor.selection.moveToBookmark(bookmark);
                        } else {
                            editor.insertContent(pastedText);
                        }
                    });
                    editor.on('keydown', (e) => {
                        const node = editor.selection.getNode();
                        if (node.tagName === 'SPAN' && (node.classList.contains('tag-highlight') || node.classList.contains('tag-highlight-blue') || node.classList.contains('tag-highlight-green'))) {
                            if (e.key.length === 1 || e.key === ' ') {
                                e.preventDefault();
                                const textNode = document.createTextNode(e.key === ' ' ? '\u00A0' : e.key);
                                if (node.nextSibling) {
                                    node.parentNode.insertBefore(textNode, node.nextSibling);
                                } else {
                                    node.parentNode.appendChild(textNode);
                                }
                                editor.selection.setCursorLocation(textNode, textNode.length);
                                editor.focus();
                            }

                            if (e.key === 'Enter') {
                                e.preventDefault();
                                const br = document.createElement('br');
                                if (node.nextSibling) {
                                    node.parentNode.insertBefore(br, node.nextSibling);
                                } else {
                                    node.parentNode.appendChild(br);
                                }
                                editor.selection.setCursorLocation(br, 0);
                                editor.focus();
                            }

                            if (e.key === 'Backspace') {
                                e.preventDefault();
                                const previousSibling = node.previousSibling;
                                if (previousSibling && previousSibling.nodeType === Node.TEXT_NODE && previousSibling.textContent.length > 0) {
                                    previousSibling.textContent = previousSibling.textContent.slice(0, -1);
                                }
                            }

                            if (e.key === 'Delete') {
                                e.preventDefault();
                                const nextSibling = node.nextSibling;
                                if (nextSibling && nextSibling.nodeType === Node.TEXT_NODE && nextSibling.textContent.length > 0) {
                                    nextSibling.textContent = nextSibling.textContent.slice(1);
                                }
                            }

                            if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(e.key)) {
                                return;
                            }
                        }
                    });
                    editor.ui.registry.addButton('blockquoteButton', {
                        text: 'Recuo',
                        tooltip: 'Aplicar recuo',
                        onAction: function () {
                            const selectedContent = editor.selection.getContent({ format: 'html' });
                            if (selectedContent) {
                                editor.selection.setContent(`<blockquote>${selectedContent}</blockquote>`);
                            } else {
                                editor.insertContent('<blockquote><p></p></blockquote>');
                            }
                        }
                    });
                    editor.ui.registry.addButton('toggleBlockquote', {
                        text: 'Remover Recuo',
                        tooltip: 'Alternar recuo',
                        onAction: function () {
                            const node = editor.selection.getNode();
                            const blockquote = editor.dom.getParent(node, 'blockquote');
                            if (blockquote) {
                                editor.dom.remove(blockquote, true);
                            } else {
                                const selectedContent = editor.selection.getContent({ format: 'html' });
                                if (selectedContent) {
                                    editor.selection.setContent(`<blockquote>${selectedContent}</blockquote>`);
                                } else {
                                    editor.insertContent('<blockquote><p></p></blockquote>');
                                }
                            }
                        }
                    });
                },
                valid_elements: '*[*]',
                valid_classes: {
                    '*': 'tag-highlight tag-highlight-blue tag-highlight-green',
                },
                table_use_colgroups: false,
                table_style_by_css: true,
                selector: 'textarea#open-source-plugins',
                license_key: 'gpl',
                plugins: 'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
                imagetools_cors_hosts: ['picsum.photos'],
                menubar: 'file edit view insert format tools table help',
                toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | toggleBlockquote blockquoteButton |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',
                toolbar_sticky: true,
                autosave_ask_before_unload: true,
                autosave_interval: '30s',
                autosave_prefix: '{path}{query}-{id}-',
                autosave_restore_when_empty: false,
                autosave_retention: '2m',
                image_advtab: true,
                importcss_append: true,
                template_cdate_format: '[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]',
                template_mdate_format: '[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]',
                height: 600,
                image_caption: true,
                quickbars_selection_toolbar: 'bold italic | quicklink h2 h3 blockquote quickimage quicktable',
                noneditable_noneditable_class: 'mceNonEditable',
                toolbar_mode: 'sliding',
                contextmenu: 'link image imagetools table',
                skin: this.$store.state.darkTheme === 'ativo' ? 'oxide-dark' : 'oxide',
                content_css: this.$store.state.darkTheme === 'ativo' ? 'dark' : 'default',
                language: 'pt_BR',
                content_style: `
                ${this.$store.state.darkTheme === 'ativo' ? 'html, body, body.mce-content-body { background-color: #0f172a !important; color: #e2e8f0 !important; } body.mce-content-body, body.mce-content-body p, body.mce-content-body div, body.mce-content-body span, body.mce-content-body td, body.mce-content-body th, body.mce-content-body li { color: #e2e8f0 !important; } a { color: #5eead4; } table, td, th { border-color: rgba(148, 163, 184, 0.32) !important; }' : ''}
                body { font-family:Helvetica,Arial,sans-serif; font-size:14px }
                .tag-highlight { background-color: #ffeb3b; padding: 2px 4px; border-radius: 3px; font-weight: bold; color: #000; }
                .tag-highlight-blue { background-color: #90CAF9; padding: 2px 4px; border-radius: 3px; font-weight: bold; color: #000; }
                .tag-highlight-green { background-color: #4CAF50; padding: 2px 4px; border-radius: 3px; font-weight: bold; color: #000; }
                `,
            },
            proposal: {},
            requiredName: false,
            requiredText: false,
            tags: {items: [], categories: [], categories_raiz: [], items_raiz: []},
            openRaiz: [],
            allTags: {},
            allTagsColor: {},
            allTagsColorEncoded: {},
            subtitles: [],
        };
    },
    emits:['updated'],
    mounted() {
        this.proposal = this.itenIndex;
        this.listTags();
        this.listLegends();
    },
    methods: {
        highlightTagsInContent(content) {
            return content.replace(/\{([^}]+)\}/g, (match) => {
                let matchD = this.decodeHTMLEntities(match);
                if (this.allTags[matchD]) {
                    if (this.allTags[matchD].includes('{if_exists_start.') || this.allTags[matchD].includes('{if_exists_end.')) {
                        return `<span class="tag-highlight-blue">${match}</span>`;
                    } else if (this.allTags[matchD].includes('{start_loop.') || this.allTags[matchD].includes('{end_loop.')) {
                        return `<span class="tag-highlight-green">${match}</span>`;
                    } else {
                        return `<span class="tag-highlight">${match}</span>`;
                    }
                }
                return match;
            });
        },
        encodeHTML(str) {
            return str.replace(/ã/g, '&atilde;')
                    .replace(/á/g, '&aacute;')
                    .replace(/â/g, '&acirc;')
                    .replace(/é/g, '&eacute;')
                    .replace(/ê/g, '&ecirc;')
                    .replace(/í/g, '&iacute;')
                    .replace(/ó/g, '&oacute;')
                    .replace(/ô/g, '&ocirc;')
                    .replace(/õ/g, '&otilde;')
                    .replace(/ú/g, '&uacute;')
                    .replace(/ç/g, '&ccedil;');
        },
        decodeHTMLEntities(text) {
            const textArea = document.createElement('textarea');
            textArea.innerHTML = text;
            return textArea.value;
        },
        alterOpenRaiz(key) {
            if (this.openRaiz[key] === undefined) this.openRaiz[key] = {};
            this.openRaiz[key].open = !this.openRaiz[key]?.open
        },
        chooseColorNameTag(tag) {
            if (tag.includes('{if_exists_start.') || tag.includes('{if_exists_end.')) {
                return 'bg-info text-white';
            }
            if (tag.includes('{start_loop.') || tag.includes('{end_loop.')) {
                return 'bg-primary text-white';
            }
            return '';
        },
        copyText(id, textTag) {
            navigator.clipboard.writeText(textTag);
        },
        colorTag(key) {
            if (key > 6) key = (key % 6) - 1;
            if (key === 0) return 'text-primary';
            if (key === 1) return 'text-secondary';
            if (key === 2) return 'text-info';
            if (key === 3) return 'text-warning';
            if (key === 4) return 'text-success';
            if (key === 5) return 'text-danger';
            if (key === 6) return 'text-success';
            if (key) return 'text-primary';
        },
        listTags() {
            this.$store.commit('changeLoading', true);
            Tags.list().then(resp => {
                resp.data.forEach(item => {
                    this.allTags[item.traduction_tag] = item.name_tag
                    if (item.categoria_raiz && !this.tags.categories_raiz.includes(item.categoria_raiz)) {
                        this.tags.categories_raiz.push(item.categoria_raiz);
                    } else if (!item.categoria_raiz) {
                        if (!this.tags.categories.includes(item.category)) {
                            this.tags.categories.push(item.category);
                        }
                    }
                });
                for (const respKey in this.allTags) {
                    if (this.allTags[respKey].includes('{if_exists_start.') || this.allTags[respKey].includes('{if_exists_end.')) {
                        this.allTagsColor[respKey] = `<span class="tag-highlight-blue">${respKey}</span>`;
                        this.allTagsColorEncoded[respKey] = `<span class="tag-highlight-blue">${this.encodeHTML(respKey)}</span>`;
                    } else if (this.allTags[respKey].includes('{start_loop.') || this.allTags[respKey].includes('{end_loop.')) {
                        this.allTagsColor[respKey] = `<span class="tag-highlight-green">${respKey}</span>`;
                        this.allTagsColorEncoded[respKey] = `<span class="tag-highlight-green">${this.encodeHTML(respKey)}</span>`;
                    } else {
                        this.allTagsColor[respKey] = `<span class="tag-highlight">${respKey}</span>`;
                        this.allTagsColorEncoded[respKey] = `<span class="tag-highlight">${this.encodeHTML(respKey)}</span>`;
                    }
                }
                this.tags.categories.forEach((category, key) => {
                    this.tags.items[key] = []
                    resp.data.forEach(item => {
                        if (item.category === category) {
                            this.tags.items[key].push(item);
                        }
                    });
                })
                this.tags.categories_raiz.forEach((category, key) => {
                    this.tags.items_raiz[key] = [];
                    resp.data.forEach(item => {
                        if (item.categoria_raiz === category) {
                            this.tags.items_raiz[key].push(item);
                        }
                    });
                })
                if (this.tags.items_raiz?.length) {
                    this.tags.items_raiz.forEach((item, key) => {
                        let aux = {};
                        item?.forEach(i => {
                            if (!aux[i.category]) {
                                if (aux[i.category] === undefined) aux[i.category] = [];
                                aux[i.category].push(i);
                            } else {
                                aux[i.category].push(i);
                            }
                        })
                        this.tags.items_raiz[key] = aux;
                    })
                }
                this.proposal.text = this.highlightTagsInContent(this.proposal.text);
                this.$store.commit('changeLoading', false);
            }).catch(() => {
                this.$store.commit('changeLoading', false);
            });
        },
        listLegends() {
            const allotmentId = this.proposal?.allotments ? this.proposal?.allotments[0]?.id : null
            this.$store.commit('changeLoading', true);

            SimulatorConfig.listInstallmentPosition(allotmentId)
                    .then(({data}) => this.subtitles = data)
                    .catch(err => this.errorMsg(err))
                    .finally(() => this.$store.commit('changeLoading', false));
        },
        updateTemplate() {
            let data = JSON.parse(JSON.stringify(this.proposal));
            if (this.allTags){
                for (const key in this.allTagsColor) {
                    data.text = data.text.replaceAll(this.allTagsColor[key], key);
                }
                for (const key in this.allTagsColorEncoded) {
                    data.text = data.text.replaceAll(this.allTagsColorEncoded[key], key);
                }
            }
            data.text = this.findSpanTagHighlight(data.text);
            this.$store.commit('changeLoading', true);
            Proposal.updateTemplate(data, this.proposal.id).then(() => {
                this.toast.success(this.t('PROPOSAL.UPDATED_TEMPLATE'));
                this.$emit('updated');
                document.getElementById('closeX').click();
            }).catch(err => {
                this.$store.commit('changeLoading', false)
                this.errorMsg(err)
            });
        },
        findSpanTagHighlight(texto) {
            if (texto.includes("tag-highlight")) {
                const parser = new DOMParser();
                const doc = parser.parseFromString(texto, 'text/html');

                doc.querySelectorAll(
                        'span.tag-highlight, span.tag-highlight-blue, span.tag-highlight-green'
                ).forEach(el => {
                    const parent = el.parentNode;
                    while (el.firstChild) {
                        parent.insertBefore(el.firstChild, el);
                    }
                    el.remove();
                });

                texto = doc.body.innerHTML;
                texto = texto
                        .replaceAll('tag-highlight-blue', '')
                        .replaceAll('tag-highlight-green', '')
                        .replaceAll('tag-highlight', '');
            }
            const div = document.createElement('div');
            div.innerHTML = texto;
            div.querySelectorAll('span').forEach(span => {
                const style = span.getAttribute('style');
                if (!style || style.trim() === '') {
                    const parent = span.parentNode;
                    while (span.firstChild) {
                        parent.insertBefore(span.firstChild, span);
                    }
                    parent.removeChild(span);
                }
            });
            texto = div.innerHTML;
            return texto;
        },
        errorMsg(error) {
            const erro = error.response.data.validations.errors;

            if (erro.sql || !erro) {
                this.toast.error(error.response.data.validations.message, {
                    timeout: false,
                });
            } else {
                for (let column in erro) {
                    for (let msg in erro[column]) {
                        this.toast.error(erro[column][msg], {timeout: false});
                    }
                }
            }
        },
    },
};
</script>

<style scoped>
.mt-negative-1 {
    margin-top: -1.2%;
}

div::-webkit-scrollbar {
    width: 5px; /* width of the entire scrollbar */
}

.template-builder-modal-body {
    padding-top: 0.75rem;
}

.template-builder-layout {
    display: grid;
    gap: 0;
    grid-template-columns: minmax(240px, 300px) minmax(0, 1fr);
    height: calc(100vh - 235px);
    min-height: 520px;
}

.template-tags-panel,
.template-editor-panel {
    background: #ffffff;
    border: 1px solid #dce3ea;
    box-shadow: 0 12px 26px rgba(15, 23, 42, 0.05);
}

.template-tags-panel {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
    overflow: hidden;
    padding: 0;
}

.template-tags-panel.labels-container {
    padding-left: 0 !important;
    padding-right: 0 !important;
}

.template-editor-panel {
    height: 100%;
    min-width: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 16px 16px 6px;
}

.template-tags-block {
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 100%;
}

.template-tags-header,
.template-editor-header {
    align-items: center;
    border-bottom: 1px solid #e4ebe8;
    display: flex;
    justify-content: space-between;
}

.template-tags-header {
    padding: 14px 14px 12px;
}

.template-editor-header {
    margin-bottom: 16px;
    padding-bottom: 14px;
}

.template-tags-header__eyebrow,
.template-editor-header__eyebrow {
    color: #0e5e4e;
    display: block;
    font-size: 0.64rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    margin-bottom: 0.18rem;
    text-transform: uppercase;
}

.template-tags-header h5,
.template-editor-header h5 {
    color: #173b34;
    font-size: 0.98rem;
    font-weight: 700;
    margin: 0;
}

.template-tags-header__icon {
    align-items: center;
    background: #e7f4f0;
    color: #0e5e4e;
    display: inline-flex;
    flex: 0 0 34px;
    height: 34px;
    justify-content: center;
    width: 34px;
}

.template-editor-header__hint {
    background: #f2f8f6;
    color: #50635e;
    font-size: 0.72rem;
    font-weight: 700;
    padding: 0.42rem 0.65rem;
    white-space: nowrap;
}

.template-tags-block .lablesContainerScroll {
    flex: 1 1 auto;
    min-height: 0;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 0 0 14px;
}

.template-tags-category {
    border-bottom: 0;
    margin: 0 0 0.35rem;
}

.template-tags-category:last-child {
    border-bottom: 0;
}

.template-tags-category--nested {
    margin-bottom: 0.2rem;
}

.template-tags-category > .ml-2 {
    border-left: 2px solid #edf3f1;
    margin-left: 0.35rem !important;
    padding-left: 0.32rem;
}

.template-tags-category--nested > div[v-show] {
    border-left: 2px solid #f1f5f3;
    margin-left: 0.35rem;
    padding-left: 0.28rem;
}

.template-tags-category__toggle {
    align-items: center;
    color: #2a3d39;
    display: flex;
    font-size: 0.82rem;
    font-weight: 700;
    justify-content: space-between;
    padding: 0;
    text-decoration: none;
}

.template-tags-category__toggle:hover {
    background: #f7fbfa;
    color: #0e5e4e;
    text-decoration: none;
}

.template-tags-category__name {
    align-items: center;
    display: inline-flex;
    gap: 0.25rem;
    min-width: 0;
}

.template-tags-category__name > .icon-label {
    align-items: center;
    background: transparent;
    color: inherit;
    display: inline-flex;
    flex: 0 0 18px;
    font-size: 0.78rem;
    height: 20px;
    justify-content: center;
    width: 18px;
}

.template-tags-category__name > .icon-label.text-primary {
    background: transparent;
    color: #2563eb !important;
}

.template-tags-category__name > .icon-label.text-secondary {
    background: transparent;
    color: #7c3aed !important;
}

.template-tags-category__name > .icon-label.text-info {
    background: transparent;
    color: #0284c7 !important;
}

.template-tags-category__name > .icon-label.text-warning {
    background: transparent;
    color: #b7791f !important;
}

.template-tags-category__name > .icon-label.text-success {
    background: transparent;
    color: #16845f !important;
}

.template-tags-category__name > .icon-label.text-danger {
    background: transparent;
    color: #dc2626 !important;
}

.template-tags-category__chevron {
    color: #87938f;
    flex: 0 0 auto;
    margin-left: 0.5rem;
}

.template-tags-loop {
    background: #fff0f0;
    color: #dc2626;
    font-size: 0.58rem;
    font-weight: 800;
    letter-spacing: 0.06em;
    padding: 0.1rem 0.32rem;
    text-transform: uppercase;
}

.template-tags-list {
    gap: 0.28rem;
    padding: 0.25rem 0 0.85rem 0.12rem;
}

.template-tags-list > div {
    max-width: 100%;
    min-width: 0;
}

.template-tag-pill {
    align-items: center;
    background: #f8fbfa;
    border: 1px solid #dfe9e6;
    color: #27433d;
    cursor: pointer;
    display: inline-flex;
    font-size: 0.72rem;
    font-weight: 700;
    gap: 0.25rem;
    line-height: 1.25;
    margin: 0 !important;
    max-width: 100%;
    padding: 0.36rem 0.42rem;
    white-space: normal;
}

.template-tag-pill.bg-info {
    background: #17a2b8 !important;
    border-color: #17a2b8 !important;
    color: #ffffff !important;
}

.template-tag-pill .icon-copy {
    align-items: center;
    background: rgba(14, 94, 78, 0.08);
    color: #0e5e4e;
    display: inline-flex;
    flex: 0 0 16px;
    font-size: 0.62rem;
    height: 16px;
    justify-content: center;
    margin-left: 0.05rem;
    width: 16px;
}

.template-tag-pill.bg-info .icon-copy,
.template-tag-pill.bg-primary .icon-copy {
    background: rgba(255, 255, 255, 0.18);
    color: #ffffff;
}

.template-tag-pill:hover {
    background: #eef8f4;
    border-color: rgba(14, 94, 78, 0.18);
    box-shadow: 0 5px 12px rgba(15, 23, 42, 0.08);
    color: #0e5e4e;
    transform: translateY(-1px);
}

:global(html.dark-theme .template-tags-panel),
:global(html.dark-theme .template-editor-panel) {
    background: var(--dark-surface-2) !important;
    border-color: var(--dark-border) !important;
    box-shadow: 0 16px 34px rgba(2, 6, 23, 0.28) !important;
}

:global(html.dark-theme .template-tags-header),
:global(html.dark-theme .template-editor-header),
:global(html.dark-theme .template-tags-category) {
    border-color: rgba(94, 234, 212, 0.12) !important;
}

:global(html.dark-theme .template-tags-category > .ml-2),
:global(html.dark-theme .template-tags-category--nested > div[v-show]) {
    border-left-color: rgba(94, 234, 212, 0.12) !important;
}

:global(html.dark-theme .template-tags-category__toggle:hover) {
    background: rgba(20, 184, 166, 0.07) !important;
}

:global(html.dark-theme .template-tags-header h5),
:global(html.dark-theme .template-editor-header h5),
:global(html.dark-theme .template-tags-category__toggle) {
    color: var(--dark-text) !important;
}

:global(html.dark-theme .template-tags-header__eyebrow),
:global(html.dark-theme .template-editor-header__eyebrow),
:global(html.dark-theme .template-tags-category__toggle:hover) {
    color: var(--dark-primary) !important;
}

:global(html.dark-theme .template-tags-header__icon),
:global(html.dark-theme .template-editor-header__hint) {
    background: var(--dark-primary-soft) !important;
    color: var(--dark-primary) !important;
}

:global(html.dark-theme .template-tags-category__chevron) {
    color: var(--dark-text-muted) !important;
}

:global(html.dark-theme .template-tags-category__name > .icon-label) {
    background: transparent !important;
    color: #93c5fd !important;
}

:global(html.dark-theme .template-tags-category__name > .icon-label.text-secondary) {
    background: transparent !important;
    color: #c4b5fd !important;
}

:global(html.dark-theme .template-tags-category__name > .icon-label.text-info) {
    background: transparent !important;
    color: #7dd3fc !important;
}

:global(html.dark-theme .template-tags-category__name > .icon-label.text-warning) {
    background: transparent !important;
    color: #fcd34d !important;
}

:global(html.dark-theme .template-tags-category__name > .icon-label.text-success) {
    background: transparent !important;
    color: #86efac !important;
}

:global(html.dark-theme .template-tags-category__name > .icon-label.text-danger) {
    background: transparent !important;
    color: #fca5a5 !important;
}

:global(html.dark-theme .template-tags-loop) {
    background: rgba(248, 113, 113, 0.14) !important;
    color: #fca5a5 !important;
}

:global(html.dark-theme .template-tag-pill) {
    background: rgba(15, 23, 42, 0.30) !important;
    border-color: rgba(94, 234, 212, 0.12) !important;
    color: var(--dark-text-soft) !important;
}

:global(html.dark-theme .template-tag-pill.bg-info) {
    background: #17a2b8 !important;
    border-color: #17a2b8 !important;
    color: #ffffff !important;
}

:global(html.dark-theme .template-tag-pill.bg-primary) {
    background: #007bff !important;
    border-color: #007bff !important;
    color: #ffffff !important;
}

:global(html.dark-theme .template-tag-pill .icon-copy) {
    background: rgba(20, 184, 166, 0.12) !important;
    color: var(--dark-primary) !important;
}

:global(html.dark-theme .template-tag-pill.bg-info .icon-copy),
:global(html.dark-theme .template-tag-pill.bg-primary .icon-copy) {
    background: rgba(255, 255, 255, 0.18) !important;
    color: #ffffff !important;
}

:global(html.dark-theme .template-tag-pill:hover) {
    background: rgba(20, 184, 166, 0.10) !important;
    border-color: rgba(94, 234, 212, 0.22) !important;
    color: var(--dark-primary) !important;
}

@media (max-width: 991px) {
    .template-builder-layout {
        height: auto;
        min-height: 0;
        grid-template-columns: 1fr;
    }

    .template-tags-panel {
        height: auto;
        max-height: 320px;
    }
}

@media (max-width: 575px) {
    .template-editor-header {
        align-items: flex-start;
        flex-direction: column;
        gap: 0.75rem;
    }
}
</style>
